import type { BlockEmbed } from 'shared-types';

type LocaleData = BlockEmbed['locales'][string];

const defaultBlockData = {
  format: 'html' as const
};

const translatable: LocaleData['translatable'] = {
  openFullScreenMessage: ''
};
const defaultLocaleData: LocaleData = {
  aspectRatio: null,
  editorIframeSetZoomWidth: null,
  enableFullScreen: 'disabled' as const,
  minHeight: 600,
  scale: null,
  selectZoom: null,
  translatable,
  text: null,
  url: null,
  useAspectRatio: null
};

const localePlaceholders = {
  aspectRatio: '{{ locales.aspectRatio }}' as const,
  editorIframeSetZoomWidth: '{{ locales.editorIframeSetZoomWidth }}' as const,
  enableFullScreen: '{{ locales.enableFullScreen }}' as const,
  minHeight: '{{ locales.minHeight }}' as const,
  openFullScreenMessage:
    '{{ locales.translatable.openFullScreenMessage }}' as const,
  scale: '{{ locales.scale }}' as const,
  selectZoom: '{{ locales.selectZoom }}' as const,
  text: '{{ locales.text }}' as const,
  url: '{{ locales.url }}' as const,
  useAspectRatio: '{{ locales.useAspectRatio }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockEmbedData: BlockEmbed = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockEmbed['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
